import './label.css';

function Label({ labelFor, labelValue }) {
    return (
        <label className="labelComponent" htmlFor={labelFor}>{labelValue}</label>
    );
}

export default Label;